import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider as ReduxProvider } from "react-redux";
import { store } from './redux/store';
import "./i18n";
import "./styles/utils.css";
import { CircularProgress } from '@mui/material';
import { ConfirmationProvider } from "./context/ConfirmationModalProvider";

function Loading() {
  return (
    <div style={{ 
      display: "flex", justifyContent: "center", alignItems: "center", 
      width: "100%", height: "100vh" 
    }}>
      <CircularProgress color="primary" />
    </div>
  )
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {/* <Suspense fallback={<Loading />}> */}
      <ReduxProvider store={store}>
        <Suspense fallback={<Loading />}>
            <ConfirmationProvider>
                <App />
            </ConfirmationProvider>
        </Suspense>
      </ReduxProvider>
    {/* </Suspense> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
